import authService from 'ApiService/Auth/AuthService';
import { createContext, useEffect, useReducer, useState } from 'react';
import { toast } from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';

export const AuthContext = createContext();

const initialState = {
  user: null,
  selectedBranch: localStorage.getItem('selectedBranch') || null,
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'LOGIN':
      // if (action.token) {
      //     localStorage.setItem("token", JSON.stringify(action.token))
      // }
      return { ...state, user: action.payload };
    case 'LOGOUT':
      // localStorage.removeItem('token');
      return { ...state, user: null, selectedBranch: null };
    case 'SET_SELECTED_BRANCH':
      localStorage.setItem('selectedBranch', action.payload);
      return { ...state, selectedBranch: action.payload };
    default:
      return state;
  }
};

const HandleAuthContext = ({ children }) => {
  const router = useNavigate();
  const [state, dispatch] = useReducer(reducer, initialState);
  const [loading, setLoading] = useState(true);

  // function Logout() {
  //   dispatch({
  //     type: 'LOGOUT',
  //   });
  //   router('/auth/sign-in/student');
  //   toast.success('Logout success.');
  // }

  async function Logout() {
    try {
      const response = await authService.logout();
      if (response.data.success) {
        localStorage.removeItem('selectedBranch');

        dispatch({
          type: 'LOGOUT',
        });
        router('/auth/sign-in');
        toast.success(response.data.message);
      }
    } catch (error) {
      toast.error('Failed to logout. Please try again.');
    }
  }
  useEffect(() => {
    async function getCurrentUserData() {
      try {
        const response = await authService.getCurrentUser();
        if (response.data.success) {
          dispatch({
            type: 'LOGIN',
            payload: response.data.user,
          });
        }
      } catch (error) {
        // alert('hiee');
        console.log(error, 'error in get current');
        if (error.response) {
          if (
            error.response.data.message ===
            'For security reasons, your session has expired. Please log in again.'
          ) {
            dispatch({
              type: 'LOGOUT',
            });
            router('/');
            toast.error(error.response.data.message);
            document.cookie =
              'token=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
          }
        }
      } finally {
        setLoading(false);
      }
    }
    getCurrentUserData();
  }, []);

  return (
    <AuthContext.Provider value={{ dispatch, state, Logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export default HandleAuthContext;
